import type { MutationUpdaterFn } from '@apollo/client';

import type * as Schema from 'src/types/graphql';

export const updateCacheUpdateWorkTypes: MutationUpdaterFn<
  Schema.UpdatePreferredWorkTypesMutation
> = (cache, { data }) => {
  const _id = data?.updatePreferredWorkTypes?.viewer?._id;
  const workTypesData =
    data?.updatePreferredWorkTypes?.viewer?.workTypes || null;
  cache.modify({
    id: cache.identify({
      __typename: 'Candidate',
      _id,
    }),
    fields: {
      workTypes: () => workTypesData,
    },
  });
};

export const generateUpdateWorkTypesOptimisticResponse =
  ({ _id }: { _id: string }) =>
  ({ workTypesData }: Schema.UpdatePreferredWorkTypesMutationVariables) => {
    const workTypes = workTypesData.ids.map((id) => ({
      __typename: 'WorkType',
      id,
    }));

    return {
      __typename: 'Mutation',
      updatePreferredWorkTypes: {
        __typename: 'UpdateWorkTypesPayload',
        viewer: {
          __typename: 'Candidate',
          _id,
          workTypes,
        },
      },
    };
  };
